export const API_PATH_ApiDeviceMgmtDevicesStatusGet = '/services/devices-mgtm/apiDeviceMgmtDevicesStatusGet';
